import { LocationStrategy } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { apiBaseUrlInterceptor } from '../api/base-url-interceptor';
import { provideImaTranslations } from '../i18n/providers';
import { MemoryLocationStrategy } from '../shell/navigation/memory-location-strategy';
import { ShellNavigation } from '../shell/navigation/shell-navigation';
import { RuntimeErrorHandler } from '../shell/runtime/error-handler';
import { RuntimeFailureReporter } from '../shell/runtime/failure-reporter';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    ...provideImaTranslations(),
    /*
     * Do not use provideBrowserGlobalErrorListeners() in this MFE.
     *
     * The browser page is shared with the Shell and the React MFE. A
     * generic global Script error originating from another MFE must not
     * quarantine this Angular MFE.
     */
    {
      provide: ErrorHandler,
      useClass: RuntimeErrorHandler,
    },
    RuntimeFailureReporter,
    /*
     * Angular 22's HttpClient already uses the Fetch API, so withFetch() is
     * redundant. The interceptor rewrites the sentinel prefix that the
     * Orval-generated clients emit onto the Shell-supplied, origin-relative
     * base URL — see src/api/base-url-interceptor.ts.
     */
    provideHttpClient(withInterceptors([apiBaseUrlInterceptor])),

    provideRouter(routes, withComponentInputBinding()),
    {
      provide: LocationStrategy,
      useClass: MemoryLocationStrategy,
    },
    ShellNavigation,
  ],
};
